import React from 'react'
import NewsletterSignup from '../components/landing/newslettersignup/newsletterSignup'
import mockupimage from "../images/landing/mockup.png";
import siteLogo from "../images/logo.png";

const IndexPage = () => (
  <div className="container">
  <div className="row">
  <div className="col-1">&nbsp;</div>
  <div className="col-5">
  <div className="landing-mockup-container">
  <img alt="Curveball App Screenshot" src={mockupimage} />
  </div>
  </div>
  <div className="col-2">
  &nbsp;
  </div>
  <div className="col-5">
  <img alt="Curveball Logo" className="landing-logo" src={siteLogo} />
  <h1>Curveball</h1>
  <h2>Watch, play, and win live gamified sports video.</h2>
  <NewsletterSignup />
  </div>
  <div className="col-1">&nbsp;</div>
  </div>
  </div>
  )

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js